import styled from 'styled-components';

export const Container = styled.nav`
    z-index: 1000;
    background: linear-gradient(135deg, #0f3460 0%, #16213e 100%) !important;
    border-bottom: 1px solid rgba(0, 212, 255, 0.2) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    position: relative !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    width: 100% !important;
    max-width: 100vw !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
    padding-left: 0.35rem !important;
    padding-right: 0.35rem !important;

    .topbar-nav-actions {
        flex: 1 1 0 !important;
        min-width: 0 !important;
        margin-left: 0.25rem !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-end !important;
        column-gap: 0.35rem !important;
    }

    /* desktop: só largura do conteúdo — evita banca esticada à esquerda e utilizador à direita com vazio enorme */
    .topbar-bank-item {
        min-width: 0 !important;
        flex: 0 0 auto !important;
    }

    .topbar-user-item {
        flex: 0 0 auto !important;
    }

    .topbar-bank-trigger {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        min-width: 0 !important;
        max-width: 100% !important;
        column-gap: 0.2rem !important;
    }

    .topbar-broker-wrap {
        display: block !important;
        min-width: 0 !important;
        /* não cresce: mantém rótulo encostado ao valor */
        flex: 0 1 auto !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .topbar-amount {
        flex-shrink: 0 !important;
        white-space: nowrap !important;
        font-weight: 800 !important;
        font-size: 1.25rem !important;
        line-height: 1.2 !important;
    }

    .topbar-amount-value {
        white-space: nowrap !important;
        font-weight: bolder !important;
        font-size: inherit !important;
    }

    .topbar-caret-wrap {
        flex-shrink: 0 !important;
        line-height: 0 !important;
    }

    .topbar-user-trigger {
        display: flex !important;
        align-items: center !important;
        padding-left: 0.35rem !important;
        padding-right: 0.35rem !important;
    }

    .topbar-avatar {
        flex-shrink: 0 !important;
    }

    @media (max-width: 767px) {
        padding-left: 0.25rem !important;
        padding-right: 0.25rem !important;

        /* mobile: item pode encolher para ellipsis + valor junto do avatar */
        .topbar-bank-item {
            flex: 1 1 0 !important;
            min-width: 0 !important;
        }

        .topbar-bank-trigger {
            padding: 0.35rem 0.15rem !important;
            justify-content: flex-end !important;
        }

        .topbar-broker-wrap {
            font-size: 0.68rem !important;
            line-height: 1.2 !important;
        }

        .topbar-amount {
            font-size: 0.95rem !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }

        .topbar-caret-icon {
            width: 18px !important;
            height: 18px !important;
        }

        .topbar-avatar {
            width: 32px !important;
            height: 32px !important;
            min-width: 32px !important;
            object-fit: cover !important;
        }
    }
    
    .navbar-nav {
        .nav-item {
            position: relative !important;
            z-index: 1001 !important;
            
            .nav-link {
                color: #e0e0e0 !important;
                
                &:hover {
                    color: #00d4ff !important;
                }
                
                .text-white {
                    color: #e0e0e0 !important;
                }
            }
        }
    }
    
    .dropdown-menu {
        z-index: 1050 !important;
        position: absolute !important;
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%) !important;
        border: 1px solid rgba(0, 212, 255, 0.2) !important;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
        border-radius: 12px !important;
        padding: 4px !important;
        min-width: 180px !important;
        gap: 0 !important;

        .dropdown-divider {
            border-top-color: rgba(0, 212, 255, 0.18) !important;
            margin: 6px 8px !important;
        }

        .dropdown-header {
            color: rgba(180, 195, 220, 0.85) !important;
            font-size: 0.7rem !important;
            font-weight: 700 !important;
            letter-spacing: 0.06em !important;
            text-transform: uppercase !important;
            padding: 8px 16px 4px !important;
        }

        .dropdown-item {
            color: #e0e0e0 !important;
            border-radius: 8px !important;
            padding: 14px 16px !important;
            margin: 0 !important;
            transition: all 0.2s ease !important;
            display: flex !important;
            align-items: center !important;
            cursor: pointer !important;
            width: 100% !important;
            box-sizing: border-box !important;
            line-height: 1.5 !important;
            min-height: 48px !important;
            text-decoration: none !important;
            user-select: none !important;
            border: none !important;
            background: transparent !important;
            text-align: left !important;
            font-family: inherit !important;
            font-size: inherit !important;
            
            &:hover {
                background: rgba(0, 212, 255, 0.2) !important;
                color: #00d4ff !important;
                text-decoration: none !important;
                
                i {
                    color: #00d4ff !important;
                }
            }
            
            &:active,
            &:focus {
                background: rgba(0, 212, 255, 0.25) !important;
                color: #00d4ff !important;
                text-decoration: none !important;
                outline: none !important;
            }
            
            i {
                color: #00d4ff !important;
                margin-right: 12px !important;
                width: 18px !important;
                text-align: center !important;
                transition: all 0.2s ease !important;
                flex-shrink: 0 !important;
                pointer-events: none !important;
            }
            
            span {
                flex: 1;
                pointer-events: none !important;
            }
        }

        .topbar-dropdown-item--danger {
            color: rgba(255, 120, 120, 0.95) !important;

            &:hover {
                background: rgba(231, 76, 60, 0.18) !important;
                color: #ffb4b4 !important;
            }

            i {
                color: rgba(255, 130, 130, 0.9) !important;
            }
        }
    }
    
    .img-profile {
        border: 2px solid rgba(0, 212, 255, 0.3) !important;
        transition: all 0.3s ease !important;
        
        &:hover {
            border-color: rgba(0, 212, 255, 0.6) !important;
            box-shadow: 0 0 10px rgba(0, 212, 255, 0.3) !important;
        }
    }
    
    .topbar-divider {
        border-left: 1px solid rgba(0, 212, 255, 0.25) !important;
    }

    #sidebarToggleTop {
        color: #e0e0e0 !important;
        
        &:hover {
            color: #00d4ff !important;
        }
    }
`;

export const LogoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-right: auto;
    flex-shrink: 0;
    min-width: 0;
    
    a {
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: transform 0.3s ease;
        min-width: 0;
        
        &:hover {
            transform: scale(1.05);
        }
    }
    
    img {
        width: auto;
        object-fit: contain;
    }

    @media (min-width: 768px) {
        img {
            height: 50px;
        }
    }

    @media (max-width: 767px) {
        gap: 0;
        /* sem mr-auto: o bloco da direita (flex:1) pode encolher e truncar a banca em vez de overflow */
        margin-right: 0;
        max-width: min(96px, 26vw);
        flex-shrink: 0;

        img {
            height: 24px;
            max-width: 100%;
        }
    }
`;

export const SalesTitle = styled.h1`
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    i {
        color: #f29205;
        font-size: 26px;
        text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
    }
    
    @media (max-width: 768px) {
        font-size: 20px;
        
        i {
            font-size: 22px;
        }
    }
`;

export const CompanySelector = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 20px;
    
    @media (max-width: 768px) {
        margin-right: 10px;
    }
    
    label {
        color: #e0e0e0;
        font-size: 14px;
        font-weight: 500;
        margin: 0;
        white-space: nowrap;
        
        @media (max-width: 768px) {
            display: none;
        }
    }
    
    select {
        background: rgba(0, 212, 255, 0.1);
        border: 1px solid rgba(0, 212, 255, 0.3);
        border-radius: 8px;
        color: #ffffff;
        padding: 8px 12px;
        font-size: 14px;
        font-weight: 500;
        min-width: 200px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        @media (max-width: 768px) {
            min-width: 150px;
            font-size: 13px;
            padding: 6px 10px;
        }
        
        &:hover {
            background: rgba(0, 212, 255, 0.15);
            border-color: rgba(0, 212, 255, 0.5);
        }
        
        &:focus {
            outline: none;
            background: rgba(0, 212, 255, 0.2);
            border-color: rgba(0, 212, 255, 0.6);
            box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
        }
        
        option {
            background: #1a1a2e;
            color: #ffffff;
        }
    }
`;
